import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { request } from './request';

export const del = <T, R = AxiosResponse<T>>(
  url: string,
  data?: T,
  config?: AxiosRequestConfig<T>,
) => {
  return request<T, R>({ method: 'delete', url, data, ...config });
};
